import { render, staticRenderFns } from "./ScoreMultiplierIcon.vue?vue&type=template&id=35849eb3"
import script from "./ScoreMultiplierIcon.vue?vue&type=script&lang=js"
export * from "./ScoreMultiplierIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports